var addToCart = function addToCart(data) {
  var _data$product, _data$product$price, _data$product2;
  var value = data == null ? void 0 : (_data$product = data.product) == null ? void 0 : (_data$product$price = _data$product.price) == null ? void 0 : _data$product$price.fullPrice;
  var prodId = data == null ? void 0 : (_data$product2 = data.product) == null ? void 0 : _data$product2.variationId;
  if (/^[0-9]+$/.test(prodId)) {
    prodId = "PLA-".concat(prodId.substring(0, 7));
  } else {
    prodId = "PLA-".concat(prodId);
  }
  window.uetq = window.uetq || [];
  window.uetq.push('event', 'add_to_cart', {
    currency: 'BRL',
    ecomm_pagetype: 'product',
    ecomm_prodid: prodId,
    ecomm_totalvalue: value,
    items: [{
      id: prodId,
      price: value,
      quantity: 1
    }],
    revenue_value: value
  });
};
export default addToCart;